import { render, staticRenderFns } from "./asset-list.vue?vue&type=template&id=06fadc3a&scoped=true&"
import script from "./asset-list.vue?vue&type=script&lang=ts&"
export * from "./asset-list.vue?vue&type=script&lang=ts&"
import style0 from "./asset-list.vue?vue&type=style&index=0&id=06fadc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fadc3a",
  null
  
)

export default component.exports